export class VerifyRegisterOtp {
  constructor(authApiClient) {
    this.authApiClient = authApiClient;
  }

  execute(payload) {
    return this.authApiClient.verifyRegisterOtp(payload);
  }
}
